// Site-wide config. Update these in one place.

// Main LinkedIn Lab Reports newsletter URL (Substack)
// Replace with your actual Substack URL once it's live.
export const SUBSTACK_URL = "https://thelinkedinlabreports.substack.com";

// Reports brand name (used in CTAs)
export const NEWSLETTER_NAME = "LinkedIn Lab Reports";

// Tagline shown under newsletter CTAs
export const NEWSLETTER_TAGLINE =
  "Weekly notes on what's actually working on LinkedIn for B2B founders. No fluff.";
